export default __webpack_public_path__ + "static/media/no_home.f1c92f77.svg";